import * as React from 'react';
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Row, Col } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { EnhancedProps } from 'src/pages/student/models/props';
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";
import InfoBox from "src/components/mission/InfoBox";

export interface StudentPreGameProps extends EnhancedProps, LocalizeContextProps {
}

interface StudentPreGameState {
    translationKey: string;
    translationStep: number;
    translationArray: string[];
}

/**
 * Dialog box with header, body text, and an actual button (not a next arrow button)
 * This page includes the terrain, star pilot, and star pod
 */
class StudentPreGame extends React.Component<StudentPreGameProps, StudentPreGameState> {
    constructor(props: StudentPreGameProps) {
        super(props);
        bindAllOfThis(this, StudentPreGame.prototype);

        this.state = {
            translationKey: "",
            translationStep: 0,
            translationArray: []
        };
    }

    componentDidMount(): void {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillReceiveProps(nextProps: StudentPreGameProps) {
        if (this.props.activeLanguage !== nextProps.activeLanguage ||
            this.props.User.gradeId !== nextProps.User.gradeId ||
            this.props.Mission.current.planetId !== nextProps.Mission.current.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.onBack();
            }
        }
    }

    hasNextButton(): boolean {
        return true;
    }

    hasBackButton(): boolean {
        return true;
    }

    onNext() {
        // Update the state step first
        let step = this.state.translationStep + 1;
        if (step < this.state.translationArray.length) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onNext();
    }

    onBack() {
        // Update the state step first (go backwards)
        let step = this.state.translationStep - 1;
        if (step >= 0) {
            this.setState({
                translationStep: step
            });
            return;
        }
        this.props.onBack();
    }

    deriveStateFromProps(newProps: StudentPreGameProps) {
        let translatedKey = "%game%.Intro.PostVid"
            .replace("%game%", newProps.currentGame.name)
            .replace("%planet%", newProps.currentPlanet.name)
            .replace("%grade%", newProps.currentGrade.name)
            .replace("%gradeNumber%", newProps.currentGrade.shortName);
        let translatedText = newProps.translate(translatedKey).toString();
        let translatedArray = (translatedText || "").split("|").map(x => x.trim());
        let translatedStep = newProps.Mission.currentDirection === "forwards" ? 0 : translatedArray.length - 1;

        this.setState({
            translationKey: translatedKey,
            translationArray: translatedArray,
            translationStep: translatedStep,
        } as StudentPreGameState);
    }

    renderHeader() {
        if (this.state.translationStep === this.state.translationArray.length - 1) {
            return <h3><Translate id="student.pregame.header" /></h3>;
        }
        return null;
    }

    render() {
        let planetCode: string = (this.props.currentPlanet || { name: "" }).name.toLowerCase() as string;
        let currentDialog: string = (this.state.translationArray || [""])[this.state.translationStep];

        let translationKey = this.state.translationKey;
        // If there are breaks in the audio, load the parted audio instead
        if (this.state.translationArray.length > 1) {
            translationKey = `${translationKey}.part${this.state.translationStep + 1}`;
        }
        let audioTrans = AudioTranslations.FindByKeyAndLanguage(translationKey, this.props.activeLanguage.code);
        this.props.onChangeAudio(audioTrans.url);

        return <div>
            <Row>
                <Col className="dialog-content" xs={{ span: 22, push: 1 }} md={{ span: 16 }} lg={16} xl={14}>
                    <DialogBox
                            currentGrade={this.props.currentGrade}
                            currentPlanet={this.props.currentPlanet}
                            buttonNextType={this.hasNextButton() ? "arrow" : "none"}
                            buttonBackType={this.hasBackButton() ? "arrow" : "none"}
                            onBack={this.onBack}
                            onNext={this.onNext}>
                        {/* {this.renderHeader()} */}
                        <p>{currentDialog}</p>
                    </DialogBox>
                </Col>
            </Row>
            <div className={`star-pilot star-pilot-${planetCode}`} />
            <div className={`star-pod star-pod-landed star-pod-${planetCode}-landed`} />
            <div className={`planet-terrain planet-terrain-${planetCode}`} />
        </div>;
    }
}

export default withLocalize(StudentPreGame);



// WEBPACK FOOTER //
// ./src/pages/student/scenes/StudentPreGame.tsx